export class ModalService {
  constructor($compile, $rootScope) {
    'ngInject';
    
    this.$compile = $compile;
    this.$rootScope = $rootScope;

    this.modals = {};
  }

  create(id,  options) {
    options['modalId'] = id;

    let newScope = this.$rootScope.$new(true);

    let element = $('body');
    
    let okAction = '$ctrl.' + options['okAction'] + '()';

    let html = `<modal modal-id="'${id}'" on-ok="${okAction}"></modal>`;
  
    element.append(this.$compile(html)(newScope));

    // Its weird the the scope became child
    newScope = newScope.$$childHead;

    newScope.modalTitle = options.title;
    newScope.modalContent = options.content;

    this.modals[id] = newScope; 
  }

  show(id) {
    $('#' + id).modal('show');
  }

  setTitle(id, newTitle) {
    let scope = this.modals[id];
    scope.modalTitle = newTitle;
  }
}

export default ModalService;



// WEBPACK FOOTER //
// ./client/app/shared/ui/modal/modal.service.js